import { render, staticRenderFns } from "./Step4_FileUpload.vue?vue&type=template&id=6f6cad94&"
import script from "./Step4_FileUpload.vue?vue&type=script&lang=js&"
export * from "./Step4_FileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports